export default __webpack_public_path__ + "static/media/gallery - story - bard (1)_03.4f6a1664.jpg";